import React from 'react';

const EmployeeRecalledSheet = () => {
    return (
        <div style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                How Can I Resubmit a Recalled Timesheet?
            </h3>
            
            <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                This section provides guidance on handling recalled timesheets. A timesheet is recalled when the approval manager or super admin requests corrections. Employees can review the comments and resubmit their timesheets accordingly.
            </p>

            <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#000", marginTop: "20px" }}>
                Steps to Recall a Timesheet:
            </h4>

            <ul style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", paddingLeft: "20px" }}>
                <li>Select the sheets you want to recall.</li>
                <li>Click the checkboxes on the left side of the selected sheets.</li>
                <li>Go to the <strong>Options</strong> menu and click on it.</li>
                <li>Click on the <strong>Recall</strong> button.</li>
            </ul>

            <img
                style={{ width: "60%", borderRadius: "8px", marginTop: "10px", display: "block" }}
                src="https://res.cloudinary.com/danfpnuui/image/upload/v1737459323/WhatsApp_Image_2025-01-21_at_4.41.17_PM_um26fw.jpg"
                alt="Employee Table Screenshot"
            />

            <p style={{ fontSize: "16px", color: "#000000",  marginTop: "15px" }}><h4>Note:</h4>
                 If you press the recall button, then the submitted sheets are recalled.
            </p>

            <p style={{ fontSize: "16px", color: "#000000",  marginTop: "5px" }}>
                Tip: If you recall a timesheet, its status changes to <strong>Pending Sheets</strong>.
            </p>
        </div>
    );
};

export default EmployeeRecalledSheet;
